import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewTicket from "./viewTicket";
import {
  viewDetails
} from "services/redux/maintenance/freshdesk/action"

const mapStateToProps = (state) => ({
    fdTicketDetails: state.FreshdeskReducer.fdTicketDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    viewDetails,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewTicket);
